if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    if (window.location.pathname.includes("/products")) {

        const intervalId = setInterval(() => {
            const qtyTableRowElems = document.querySelectorAll('.bss-b2b-qty-table-row');
            const inputQty = document.querySelector('input.quantity__input[id^="Quantity-"]');

            if (qtyTableRowElems.length > 0 && inputQty) {

                qtyTableRowElems.forEach((qtyTableRowElem) => {
                    qtyTableRowElem.addEventListener('click', function (e) {
                        console.log("Clicked row");
                        const event = new Event('change', { bubbles: true });
                        inputQty.dispatchEvent(event);
                    });
                });

                clearInterval(intervalId);
            }
        }, 300); 
        
        setTimeout(() => {
            clearInterval(intervalId)
        }, 8000);
    }
}
